import { EthereumStakingValidatorInfo } from '#/data/react-query/queries/order-list';
import React from 'react';
import { Hex } from 'viem';
import { InterpreterFrom, assign, createMachine } from 'xstate';

interface MachineContext {
  target: EthereumStakingValidatorInfo | null;
  transactionHash: Hex | null;
}
const machine = createMachine<MachineContext>({
  predictableActionArguments: true,
  preserveActionOrder: true,
  context: {
    target: null,
    transactionHash: null,
  },
  initial: 'information',
  states: {
    information: {
      on: {
        NEXT: {
          target: 'transaction',
        },
      },
    },
    transaction: {
      tags: 'loading',
      invoke: {
        src: 'onTransaction',
        onDone: {
          target: 'transactionReceipt',
          actions: assign((context, event) => {
            const { transactionHash } = event.data;
            return { transactionHash };
          }),
        },
        onError: 'information',
      },
    },
    transactionReceipt: {
      tags: 'completed',
    },
  },
});

const MachineContext = React.createContext(
  {} as InterpreterFrom<typeof machine>
);

export { MachineContext };

export default machine;
